import { AutoMap } from "@automapper/classes";

export class AreaMapDTO {
    @AutoMap()
    legend!: string;
    @AutoMap()
    comment!: string;
    @AutoMap()
    jsonContent?: string;
    @AutoMap()
    backgroundPicture?: string;
    @AutoMap()
    data?: string;
}
